export default {
    data: () => ({
        translations: {
            title: {
                el: "",
                en: "Customers Base",
                it: ""
            },
            all: {
                el: "Όλοι",
                en: "All",
                it: "Tutto"
            },
            stores: {
                el: "Καταστήματα",
                en: "Stores",
                it: "I negozi"
            },
            receiveNews: {
                el: "Επιθυμώ να λαμβάνω νέα και προσφορές απο την εταιρία",
                en: "Receive news and offers from the company",
                it: "Desidero ricevere notizie e offerte dall'azienda"
            },
            selectOneOrMore: {
                el: "Επιλέξτε ένα ή περισσότερα μέσα ενημέρωσης του πελάτη",
                en: "Select one or more means to inform the customer",
                it: "Seleziona uno o più mezzi per informare il cliente"
            },
            info: {
                el: "Εδώ έχετε τη λίστα των πελατών σας που συλλέγονται από όλες τις διαφορετικές πηγές, όπως εφαρμογές για κινητά, συσκευές POS, κάρτες πιστότητας κ.λπ. Προσθέστε νέους πελάτες χειροκίνητα ή εισάγετε φίλτρα για τους πελάτες σας.",
                en: `
                    Here you got the list of your customers collected from all different 
                    sources like mobile apps, POS devices, loyalty cards etc. Add new customers 
                    manually or insert filters for your customers.
                `,
                it: "Qui hai la tua lista di clienti raccolta da tutte le diverse fonti, come le app mobili, i dispositivi POS, le carte fedeltà, ecc. Aggiungi nuovi clienti manualmente o inserisci dei filtri per i tuoi clienti."
            },
            addNewCustomer: {
                el: "Προσθήκη Νέου Πελάτη",
                en: "Add New Customer",
                it: "Aggiungi nuovo cliente"
            },
            customer: {
                el: "Κωδικός Πελάτη",
                en: "Customer ID",
                it: "Identificativo Del Cliente"
            },
            user_account_id: {
                el: "Κωδικός Πελάτη",
                en: "Customer ID",
                it: "Identificativo Del Cliente"
            },
            totalPrice: {
                el: "Συνολική Τιμή",
                en: "Total Price",
                it: "Prezzo totale"
            },
            total_price: {
                el: "Συνολική Τιμή",
                en: "Total Price",
                it: "Prezzo totale"
            },
            transactions: {
                el: "Συναλλαγές",
                en: "Transactions",
                it: "Transazione"
            },
            user_id: {
                el: "ID χρήστη",
                en: "user ID",
                it: "user ID"
            },
            first_name: {
                el: "Όνομα",
                en: "First Name",
                it: "Nome"
            },
            last_name: {
                el: "Επώνυμο",
                en: "Last Name",
                it: "Cognome"
            },
            total_transactions: {
                el: "Συναλλαγές",
                en: "Transactions",
                it: "Transazione"
            },
            total: {
                el: "Σύνολο Πόντων",
                en: "Total Points",
                it: "Punti Totali"
            },
            redeemed: {
                el: "Εξαργυρωμένοι Πόντοι",
                en: "Redeemed Points",
                it: "Punti Riscattati"
            },
            redeemed_points: {
                el: "Εξαργυρωμένοι Πόντοι",
                en: "Redeemed Points",
                it: "Punti Riscattati"
            },
            available: {
                el: "Διαθέσιμοι Πόντοι",
                en: "Available Points",
                it: "Punti Disponibili"
            },
            current_balance: {
                el: "Διαθέσιμοι Πόντοι",
                en: "Available Points",
                it: "Punti Disponibili"
            },
            userTab: {
                el: "",
                en: "User Tab",
                it: ""
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            updateCustomer: {
                el: "Ενημέρωση Στοιχείων Πελάτη",
                en: "Update Customer Details",
                it: "Aggiorna i Dettagli del Cliente"
            },
            customerDetails: {
                el: "Στοιχεία Πελάτη",
                en: "Customer Details",
                it: "Dettagli del Cliente"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancella"
            },
            additionalInfo: {
                el: "",
                en: "Additional Info",
                it: ""
            },
            firstName: {
                el: "Όνομα",
                en: "First Name",
                it: "Nome"
            },
            lastName: {
                el: "Επώνυμο",
                en: "Last Name",
                it: "Cognome"
            },
            cardNumbers: {
                el: "Αριθμοί Καρτών",
                en: "Card Numbers",
                it: "Numeri di carta"
            },
            address: {
                el: "Διεύθυνση",
                en: "Address",
                it: "Indirizzo"
            },
            gender: {
                el: "Φύλο",
                en: "Gender",
                it: "Sesso"
            },
            birthDate: {
                el: "Ημερομηνία Γέννησης",
                en: "Date of Birth",
                it: "Data di nascita"
            },
            selectAll: {
                el: "Επιλογή Όλων",
                en: "Select All",
                it: "Selezione di Tutti"
            },
            deselectAll: {
                el: "Αποεπιλογή Όλων",
                en: "Deselect All",
                it: "Chiedete Scusa a Tutti"
            },
            cardNumber: {
                el: "Αριθμός Κάρτας",
                en: "Card Number",
                it: "Numero di carta"
            },
            card_number: {
                el: "Αριθμός Κάρτας",
                en: "Card Number",
                it: "Numero di carta"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            mobile: {
                el: "Κινητό",
                en: "Mobile",
                it: "Cellulare"
            },
            form_date: {
                el: "Ημερομηνία",
                en: "Form Date",
                it: "Data"
            },
            store: {
                el: "Κατάστημα",
                en: "Store",
                it: "Negozio"
            },
            cc: {
                el: "Χώρα",
                en: "Country Code",
                it: "Nazione"
            },
            landlinePhone: {
                el: "Σταθερό Τηλέφωνο",
                en: "Landline Number",
                it: "Telefono fisso"
            },
            postCode: {
                el: "Τ.Κ",
                en: "Postcode",
                it: "Codice Postale"
            },
            country: {
                el: "Νομός",
                en: "State",
                it: "Provincia"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            cardNumbersActivated: {
                el: "Ενεργοποιημένες κάρτες",
                en: "Activated cards",
                it: "Carte attivate"
            },
            storePoints: {
                el: "Πόντοι καταστήματος",
                en: "Store points",
                it: "Punti vendita"
            },
            merge: {
                el: "Συγχώνευση",
                en: "Merge",
                it: "Unire"
            },
            mergeSuccess: {
                el: "Επιτυχής συγχώνευση",
                en: "Merged successfuly",
                it: "Fusione riuscita"
            },
            mergeUserId: {
                el: "Συγχώνευση του χρήστη με κινητό",
                en: "Merge",
                it: "Unire"
            },
            phone: {
                el: "Τηλέφωνο",
                en: "Mobile phone",
                it: "Telefono"
            },
            absorb: {
                el: " που θα συγχωνευτεί",
                en: " to absorb",
                it: " assorbire"
            },
            keep: {
                el: " που θα διατηρηθεί",
                en: " to keep",
                it: " mantenere"
            },
            into: {
                el: "στον χρήστη με κινητό",
                en: "into",
                it: "in"
            },
            mergeProcess24h: {
                el: "Η διαδικασία συγχώνευσης μπορεί να διαρκέσει εώς και 24 ώρες.",
                en: "The merging process can last up to 24 hours.",
                it: "Il processo di fusione può durare fino a 24 ore."
            },
            addCard: {
                el: "Προσθήκη Κάρτας",
                en: "Add Card",
                it: "Aggiungi Carta"
            },
            visibleColumns: {
                el: "Ορατές Στήλες",
                en: "Visible Columns",
                it: "Colonne Visibili"
            },
            formDate: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Date"
            },
            changeMobile: {
                el: "Αλλαγή αριθμού κινητού τηλεφώνου",
                en: "Change Mobile Phone Number",
                it: "Modifica del numero di cellulare"
            },
            save: {
                el: 'Αποθήκευση',
                en: 'Save',
                it: 'Salva',
            },
             cancel: {
                el: 'Ακύρωση',
                en: 'Cancel',
                it: 'Cancella',
            },
            clearPoints: {
                el: 'Αφαίρεση όλων των πόντων πελάτη',
                en: 'Remove All Customer Points',
                it: 'Rimuovere tutti i punti cliente',
            },
            
            clearPointsConfirmation1: {
                el: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε όλους τους πόντους για τον πελάτη με στοιχεία:',
                en: 'Are you sure you want to remove all the points for customer:',
                it: 'Si è sicuri di voler rimuovere tutti i punti per il cliente con i dati:',
            },
            detachCard: {
               el: 'Αποσύνδεση κάρτας πελάτη',
               en: 'Detach Customer Card',
               it: 'Staccare la scheda cliente',
           },
           
           submit: {
                el: "Υποβολή",
                en: "Submit",
                it: "Invia" 
            },
                
            detachCardConfirmation1: {
                el: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε την κάρτα για τον πελάτη με στοιχεία:',
                en: 'Are you sure you want to remove the card for customer:',
                it: 'È sicuro di voler rimuovere la scheda per il cliente:',
            },
           
            importCustomers: {
                 el: "Εισαγωγή πελατών",
                 en: "Import Customers",
                 it: "Importazione di clienti" 
             },
           
             importCustomersDescription: {
                  el: "Επιλέξτε το αρχείο CSV που περιέχει τους πελάτες που θέλετε να εισαγάγετε.",
                  en: "Select the CSV file containing the customers you wish to import.",
                  it: "Selezionare il file CSV contenente i clienti che si desidera importare." 
              },
              
            moreActions: {
                el: "Περισσότερες ενέργειες",
                en: "More Actions",
                it: "Altre azioni"
            },
            attributes: {
                el: "Ιδιότητες",
                en: "Attributes",
                it: "Attributi" 
            },
            
            customAttributes: {
                el: "Προσαρμοσμένες Ιδιότητες",
                en: "Custom Attributes",
                it: "Attributi personalizzati" 
            },
            type: {
                el: "Τύπος",
                en: "Type",
                it: "Tipo" 
            },
            input: {
                el: "Πεδίο",
                en: "Input",
                it: "Ingresso" 
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            options: {
                el: "Επιλογές",
                en: "Options",
                it: "Opzioni"
            },
            for: {
                el: "για",
                en: "for",
                it: "per"
            },
            option: {
                el: "Επιλογή",
                en: "Option",
                it: "Opzione"
            },
            createNewAttribute: {
                el: "Δημιουργία Νέας Ιδιότητας",
                en: "Create New Attribute",
                it: "Creare un nuovo attributo"
            },
            editAttribute: {
                el: "Επεξεργασία Ιδιότητας",
                en: "Edit Attribute",
                it: "Modifica attributo"
            },
            deleteAttribute: {
                el: "Διαγραφή Ιδιότητας",
                en: "Delete Attribute",
                it: "Cancella attributo"
            },
            
            addNewOption: {
                el: "Προσθήκη νέας επιλογής",
                en: "Add New Option",
                it: "Aggiungi nuova opzione"
            },
            
            createAttributeSuccess: {
                el: "Η ιδιότητα δημιουργήθηκε επιτυχώς",
                en: "Attribute was created successully",
                it: "L'attributo è stato creato con successo"
            },
            updateAttributeSuccess: {
                el: "Η ιδιότητα ενημερώθηκε επιτυχώς",
                en: "Attribute was updated successully",
                it: "L'attributo è stato aggiornato con successo"
            },
            deleteAttributeSuccess: {
                el: "Η ιδιότητα διαγράφηκε επιτυχώς",
                en: "Attribute was deleted successully",
                it: "L'attributo è stato cancellato con successo"
            },
            deleteAttributeConfirmation1: {
                el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την ιδιότητα με στοιχεία:',
                en: 'Are you sure you want to delete the following attribute:',
                it: 'Si è sicuri di voler eliminare il seguente attributo :',
            },
            deletePermanently: {
                el: "Οριστική διαγραφή",
                en: "Delete permanently",
                it: "Cancellare definitivamente"
            },
            deleteCustomer: {
                el: "Οριστική διαγραφή πελάτη",
                en: "Delete customer",
                it: "Cancellare cliente"
            },
            deleteCustomerSuccess: {
                el: "Ο/Η χρήστης διαγράφηκε επιτυχώς",
                en: "The customer was deleted successully",
                it: "Il cliente è stato cancellato con successo"
            },
            deleteCustomerConfirmation1:{
                el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε τον χρήστη με στοιχεία:',
                en: 'Are you sure you want to delete the following customer:',
                it: 'Si è sicuri di voler eliminare il seguente cliente :',

            },
            number: {
                el: "Αριθμός",
                en: "Number",
                it: "Numero"
            },
            text: {
                el: "Κείμενο",
                en: "Text",
                it: "Testo"
            },
            
            invalidValue: {
                el: "Μη έγκυρη τιμή: Παρακαλώ, πληκτρολογήστε έναν αριθμό",
                en: "Invalid value: Please, type a number",
                it: "Valore non valido: Digitare un numero"
            },
            notifications: {
                el: "Ειδοποιήσεις",
                en: "Notifications",
                it: "Notifiche"
            },
            campaign_title: {
                el: "Τίτλος Καμπάνιας",
                en: "Campaign Title",
                it: "Titolo della campagna"
            },
            system_notification_type: {
                el: "Τυπος ειδοποίησης",
                en: " Notification Type",
                it: "Notifica di sistema"
            },
            notification_category_system: {
                el: "Κατηγορία ειδοποιήσεων",
                en: "Not. Category",
                it: "Categoria di notifica"
            },
            system_notification_type_filter: {
                el: "Φιλτράρισμα ανά τύπο ειδοποίησης",
                en: "Filter By Notification Type",
                it: "Filtra per tipo di notifica"
            },
            notification_category_system_filter: {
                el: "Φιλτράρισμα ανά κατηγορία",
                en: "Filter by Category",
                it: "Filtra per categoria"
            },
            system_notification_type_select: {
                el: "Επιλέξτε τύπους ειδοποίησης",
                en: "Select one or more types",
                it: "Seleziona uno o più tipi"
            },
            notification_category_system_select: {
                el: "Επιλέξτε κατηγορίες ειδοποίησης",
                en: "Select one or more categories",
                it: "Seleziona una o più categorie"
            },
            date_filter: {
                el: "Φιλτράρισμα ανά Ημερομηνία",
                en: "Filter by Date",
                it: "Filtra per data"
            },
            from_date: {
                el: "Από Ημερομηνία",
                en: "From Date",
                it: "Da Data"
            },
            to_date: {
                el: "Μέχρι Ημερομηνία",
                en: "To Date",
                it: "Ad oggi"
            },
            from: {
                el: "Από",
                en: "From",
                it: "Da"
            },
            to: {
                el: "Μέχρι",
                en: "To",
                it: "A"
            },
            body_full: {
                el: "Δείξε όλο το κείμενο",
                en: "Show full text",
                it: "Mostra il testo completo"
            },
            show_details: {
                el: "Εμφάνιση λεπτομερειών",
                en: "Show details",
                it: "Mostra dettagli"
            },
            body: {
                el: "Σώμα",
                en: "Body",
                it: "Corpo"
            },
            identifier: {
                el: "Αναγνωριστικό",
                en: "Identifier",
                it: "Identificatore"
            },
            data: {
                el: "Δεδομένα",
                en: "Data",
                it: "Dati"
            },
            status: {
                el: "Κατάσταση",
                en: "Status",
                it: "Stato"
            },
            created: {
                el: "Δημιουργήθηκε",
                en: "Created",
                it: "Creato"
            },
        }
    })
};
